import { GetterTree, MutationTree, ActionTree, Module } from "vuex";
import { RootState } from "..";
import { Material } from "@/core/_models/material.model";
import Vue from "vue";

class MaterialsState {
  items: Material[] | undefined = undefined;
}

export const state: MaterialsState = {
  items: undefined
};

const namespaced: boolean | undefined = true;

const getters = {
  items(state) {
    if (!state.items) return [];

    return state.items.sort((a, b) => (a.Index < b.Index ? -1 : 1));
  },
  item:
    (state) =>
    (DatabaseId: string): Material | undefined => {
      if (!state.items) {
        return undefined;
      }

      const material = state.items.find((x) => x.DatabaseId == DatabaseId);

      return material;
    }
} as GetterTree<MaterialsState, any>;

const mutations = {
  SET_MATERIALS(state, materials: Material[]) {
    state.items = materials;
  },
  UPDATE_MATERIAL(state, material: Material) {
    if (!state.items) return;

    const existingItem = state.items.findIndex((x) => x.DatabaseId === material.DatabaseId);

    if (existingItem !== -1) {
      Vue.set(state.items, existingItem, material);
    } else {
      state.items.push(material);
    }
  },
  REMOVE_MATERIAL(state, DatabaseId: string) {
    if (state.items != undefined) {
      state.items = state.items?.filter((x) => x.DatabaseId != DatabaseId);
    }
  }
} as MutationTree<MaterialsState>;

const actions = {
  pushMaterials({ commit, rootState }): any {
    const materials = rootState.materials.items;

    materials.forEach((material: Material) => {
      commit("UPDATE_MATERIAL", material);
    });
  }
} as ActionTree<MaterialsState, any>;

export const materials: Module<MaterialsState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
